module.exports = __webpack_public_path__ + "img/img27.96067417.png";